import { callGetAPI } from "./API-Calling-service";
const API_URL = process.env.REACT_APP_CHANGEINITIATION_API_URL + "Feasibility";
// "http://localhost:5009/Feasibility";//process.env.REACT_APP_FEASIBILITY_API_URL;
//const axios = require("axios");
 
export async function getAll() {
  return callGetAPI(API_URL);
  // console.log("Under Get all");
  // return fetch(API_URL).then((response) => response.json());
}
export async function getUsersChangeInitationdata(UserId) {
  let url = `${API_URL}/UserId/${UserId}`; 
  return callGetAPI(url);
  // console.log(url + "getUsersChangeInitationdata");
  // return fetch(url).then((response) => response.json()); 
}

export async function getUsersChangeFeasibilitydata(UserName) {
  let url = `${API_URL}/UserName/${UserName}`;  
  return callGetAPI(url);
  //return fetch(url).then((response) => response.json()); 
}

export async function getUsersChangeAnalysisdata(Name) {
  let url = `${API_URL}/Name/${Name}`; 
  return callGetAPI(url);
  // return fetch(url).then((response) => response.json()); 
}
